import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { INSIGHTS } from "../data/content";
import ContactSplit from "../components/sections/ContactSplit";
import { MaskedLine } from "../components/MaskedLine";

export default function InsightDetailPage() {
  const { slug } = useParams();
  const idx = INSIGHTS.findIndex(i => i.slug === slug);
  if (idx === -1) return <Navigate to="/insights" replace />;
  const article = INSIGHTS[idx];
  const next = INSIGHTS[(idx + 1) % INSIGHTS.length];

  return (
    <main data-testid={`page-insight-${slug}`}>
      <section className="ground-paper pt-[104px] pb-10 md:pt-[132px] md:pb-14">
        <div className="wrap max-w-[880px]">
          <Link to="/insights" className="stamp inline-flex items-center gap-2 hover:text-[color:var(--pink)]">
            <ArrowLeft size={13} /> All field notes
          </Link>

          <div className="flex items-center gap-4 mt-10">
            <span className="series-stamp"><span>{article.category}</span></span>
            <span className="stamp-dim">{article.readTime} · 1 idea</span>
          </div>

          <h1
            className="h-hero mt-10"
            style={{ fontSize: "clamp(44px, 6.5vw, 96px)" }}
            data-testid="insight-title"
          >
            <MaskedLine>{article.title}</MaskedLine>
          </h1>
        </div>
      </section>

      <section className="ground-paper pb-24">
        <article className="wrap max-w-[760px] font-aside" style={{ fontSize: "clamp(19px, 1.7vw, 22px)", lineHeight: 1.7 }}>
          {article.body.map((p, i) => (
            <p key={i} className={`mt-8 ${i === 0 ? "font-hook not-italic text-[#0E1330] leading-[1.25]" : "text-[#0E1330]"}`}
               style={i === 0 ? { fontSize: "clamp(24px, 2.6vw, 34px)", letterSpacing: "-0.015em", fontWeight: 800 } : undefined}
            >
              {p}
            </p>
          ))}
        </article>
      </section>

      <section className="ground-paper pb-24">
        <div className="wrap flex flex-wrap items-baseline justify-between gap-6 border-t-[1.5px] border-[color:var(--ink)] pt-8">
          <div>
            <p className="stamp">Next note</p>
            <Link to={`/insights/${next.slug}`} className="font-hook-black text-[#0E1330] hover:text-[color:var(--pink)] inline-flex items-center gap-3 mt-3" data-testid="insight-next-link" style={{ fontSize: "clamp(22px, 3vw, 40px)", letterSpacing: "-0.02em", lineHeight: 1 }}>
              {next.title} <ArrowUpRight size={22} />
            </Link>
          </div>
          <Link to="/insights" className="arrow-link">All notes <ArrowUpRight size={14} /></Link>
        </div>
      </section>

      <ContactSplit />
    </main>
  );
}
